<template>
  <div>
    <div id="blocActus" class="blocActusA">
      <div id="titreActus">&nbsp;Actualités</div>
      <div id="actus" v-if="$store.state.user.user && $store.state.user.user.actualite">
        <p align="justify"><img src="../assets/pucette2.gif" width="3" height="6" alt border="0" align="absmiddle" class="mr-2" /><span v-html="$store.state.user.user.actualite"></span></p>
      </div>
      <div v-else id="actus">
        <p>
          <img src="../assets/pucette2.gif" width="3" height="6" alt border="0" align="absmiddle" />
          Découvrez le guide pratique carte Affaires.
          <router-link :to="{name: 'documentation'}">En savoir +</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { hasRole } from '@/utils/utils.js'

export default {
  data: function () {
    return {
      roles: this.$store.state.user.user.rm_user
        ? this.$store.state.user.user.rm_user.roles
        : [],
      hasRole
    }
  }
}
</script>

<style lang="scss">
.blocActusA {
  background: url("../assets/bg_actualites.gif") left bottom no-repeat;
  margin: 15px 0 20px 0;
  padding: 0 0 40px 0px;
}

#titreActus {
  float: right;
  width: 98.6%;
  background-color: #a5ce55;
  color: #ffffff;
  font-size: 11px;
  padding: 3px 0 3px 0px;
  padding-left: 5px;
  font-family: verdana, arial, helvetica, sans-serif;
}
#actus {
  p {
    font-size: 12px;
    font-family: arial, helvetica, sans-serif;
    font-weight: 100;
    color: #7f7f7f;
    padding-top: 8px;
    display: inline-block;
    padding-left: 35px;
    padding-top: 25px;
  }
  a {
    color: #7f7f7f;
  }
}

span > div {
  display: contents;
}
</style>
